export const ADD_USER = 'ADD_USER'
export const ADD_USER_FAILED = 'ADD_USER_FAILED'
export const ADD_USER_SUCCEEDED = 'ADD_USER_SUCCEEDED'
export const DEACTIVATE_USERS = 'DEACTIVATE_USERS'
export const DEACTIVATE_USERS_FAILED = 'DEACTIVATE_USERS_FAILED'
export const DEACTIVATE_USERS_SUCCEEDED = 'DEACTIVATE_USERS_SUCCEEDED'
export const FETCH_MANAGED_USERS = 'FETCH_MANAGED_USERS'
export const FETCH_MANAGED_USERS_SUCCEEDED = 'FETCH_MANAGED_USERS_SUCCEEDED'
export const FETCH_MANAGED_USERS_FAILED = 'FETCH_MANAGED_USERS_FAILED'
export const FETCH_USER_ROLES = 'FETCH_USER_ROLES'
export const FETCH_USER_ROLES_FAILED = 'FETCH_USER_ROLES_FAILED'
export const FETCH_USER_ROLES_SUCCEEDED = 'FETCH_USER_ROLES_SUCCEEDED'
export const REGISTER_MANAGED_USER = 'REGISTER_MANAGED_USER'
export const REGISTER_MANAGED_USER_FAILED = 'REGISTER_MANAGED_USER_FAILED'
export const REGISTER_MANAGED_USER_SUCCEEDED = 'REGISTER_MANAGED_USER_SUCCEEDED'
export const RESEND_USER_INVITE = 'RESEND_USER_INVITE'
export const RESEND_USER_INVITE_FAILED = 'RESEND_USER_INVITE_FAILED'
export const RESEND_USER_INVITE_SUCCEEDED = 'RESEND_USER_INVITE_SUCCEEDED'
export const UPDATE_MANAGED_USER = 'UPDATE_MANAGED_USER'
export const UPDATE_MANAGED_USER_FAILED = 'UPDATE_MANAGED_USER_FAILED'
export const UPDATE_MANAGED_USER_SUCCEEDED = 'UPDATE_MANAGED_USER_SUCCEEDED'
